import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="border-t border-white/5 bg-[#09090b] mt-24" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 py-12">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          <div className="col-span-2 md:col-span-1">
            <div className="flex items-center space-x-2 mb-4">
              <img 
                src="https://customer-assets.emergentagent.com/job_xtream-store/artifacts/5y14iky3_image-removebg-preview%20%281%29.png" 
                alt="Xtream Store" 
                className="h-8 w-auto"
              />
              <span className="text-xl font-heading font-bold">Xtream Store</span>
            </div>
            <p className="text-muted-foreground text-sm leading-relaxed">
              Your trusted source for premium streaming accounts.
            </p>
          </div>
          
          <div>
            <h3 className="font-heading font-bold mb-4">Shop</h3>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li><Link to="/category/streaming" className="hover:text-white transition-colors">Streaming</Link></li>
              <li><Link to="/" className="hover:text-white transition-colors">Featured</Link></li>
            </ul>
          </div>
          
          <div>
            <h3 className="font-heading font-bold mb-4">Account</h3>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li><Link to="/dashboard" className="hover:text-white transition-colors">My Orders</Link></li>
              <li><Link to="/cart" className="hover:text-white transition-colors">Cart</Link></li>
            </ul>
          </div>
          
          <div>
            <h3 className="font-heading font-bold mb-4">Support</h3>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li><Link to="/help-center" className="hover:text-white transition-colors">Help Center</Link></li>
              <li><Link to="/privacy-policy" className="hover:text-white transition-colors">Privacy Policy</Link></li>
              <li><Link to="/terms-conditions" className="hover:text-white transition-colors">Terms & Conditions</Link></li>
            </ul>
          </div>
        </div>
        
        <div className="border-t border-white/5 mt-8 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-sm text-muted-foreground text-center md:text-left">&copy; 2025 Xtream Store. All rights reserved.</p>
            <div className="flex gap-4 text-sm text-muted-foreground">
              <Link to="/privacy-policy" className="hover:text-white transition-colors">Privacy Policy</Link>
              <Link to="/terms-conditions" className="hover:text-white transition-colors">Terms of Service</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
